export enum DateTimeFormats {
  SHORT_AMPM = 'M/d/yy, h:mm a',
  SHORT_MILITARY = 'M/d/yy, HH:mm',
}
